import { gql } from '@apollo/client';

export const CREATE_LOCAL_USER = gql`
    mutation createLocalUser($input: CreateLocalUserInput!) {
        createLocalUser(input: $input) {
            id
            userType
            userAuthType
            email
            firstName
        }
    }
`;

export const TRANSFORM_LOCAL_USER_DATA = gql`
    mutation transformLocalUserData($input: TransformLocalUserDataInput!) {
        transformLocalUserData(input: $input) {
            message
        }
    }
`;
